module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px:height: auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name))])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Invoice Number"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.InvoiceNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "InvoiceNoFilter", $$v)
      },
      expression: "Filter.InvoiceNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Shipping Bill Number"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.SBFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SBFilter", $$v)
      },
      expression: "Filter.SBFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PORfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORfilter", $$v)
      },
      expression: "Filter.PORfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PODfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODfilter", $$v)
      },
      expression: "Filter.PODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.containerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "containerTypeFilter", $$v)
      },
      expression: "Filter.containerTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.shippingLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shippingLineFilter", $$v)
      },
      expression: "Filter.shippingLineFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Container  No."
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.ContainerFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ContainerFilter", $$v)
      },
      expression: "Filter.ContainerFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Shipper Inv No."
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.shiperInvFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shiperInvFilter", $$v)
      },
      expression: "Filter.shiperInvFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Assignment No."
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.assignmentFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "assignmentFilter", $$v)
      },
      expression: "Filter.assignmentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.jobList,
      "option-value": "jv",
      "option-text": "jt",
      "placeholder": " JobType"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.jobTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "jobTypeFilter", $$v)
      },
      expression: "Filter.jobTypeFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": " Branch"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.SOBFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SOBFilter", $$v)
      },
      expression: "Filter.SOBFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.BillingStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Status"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.BillingFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "BillingFilter", $$v)
      },
      expression: "Filter.BillingFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Common Filter"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.slineFilter,
      "option-value": "slineVal",
      "option-text": "slineText",
      "placeholder": "Select Sline Filter If required"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.slineTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineTypeFilter", $$v)
      },
      expression: "Filter.slineTypeFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mt-3"
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "id": "checkbox-group-1",
      "options": _vm.jobRecList,
      "name": "flavour-1"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.jobRecFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "jobRecFilter", $$v)
      },
      expression: "Filter.jobRecFilter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 pull-right",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("\n                Reset & Close\n              ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button-group', {
    staticClass: "m2-1 text-right",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    class: 'ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ||
        _vm.Filter.clientIdFilter ||
        _vm.Filter.InvoiceNoFilter ||
        _vm.Filter.SBFilter ||
        _vm.Filter.PORfilter ||
        _vm.Filter.PODfilter ||
        _vm.Filter.containerTypeFilter ||
        _vm.Filter.shippingLineFilter ||
        _vm.Filter.ContainerFilter ||
        _vm.Filter.shiperInvFilter ||
        _vm.Filter.assignmentFilter ||
        _vm.Filter.jobTypeFilter ||
        _vm.Filter.branchfilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.SOBFilter ||
        _vm.Filter.BillingFilter ||
        _vm.Filter.jobRecFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.slineTypeFilter ?
        'danger' :
        'primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ||
    _vm.Filter.clientIdFilter ||
    _vm.Filter.InvoiceNoFilter ||
    _vm.Filter.SBFilter ||
    _vm.Filter.PORfilter ||
    _vm.Filter.PODfilter ||
    _vm.Filter.containerTypeFilter ||
    _vm.Filter.shippingLineFilter ||
    _vm.Filter.ContainerFilter ||
    _vm.Filter.shiperInvFilter ||
    _vm.Filter.assignmentFilter ||
    _vm.Filter.jobTypeFilter ||
    _vm.Filter.branchfilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.SOBFilter ||
    _vm.Filter.BillingFilter ||
    _vm.Filter.jobRecFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.slineTypeFilter ?
    "Filter ON" :
    "Filter OFF") + "\n                  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Back")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [(_vm.allpurchasesList.length > 0) ? _c('b-button', {
    staticClass: "pull-left mb-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('All_Purchases_List', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.allpurchasesList,
      "responsive": "",
      "fields": _vm.purchaseFields,
      "primary-key": "doc_id",
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "doc_id",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [_c('span', [_c('b', [_vm._v(" " + _vm._s(row1.item.AssNo) + " ")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                " + _vm._s(row1.item.jobType) + " (" + _vm._s(row1.item.shipmentType == "1" ||
          row1.item.shipmentType == "Sea_Shipment" ?
          "Sea" :
          "Air") + "\n                " + _vm._s(row1.item.transportType) + ")")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" Assignment Dt. : " + _vm._s(_vm._f("moment")(row1.item.AssDate)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" Raised From : " + _vm._s(row1.item.raisedFrom)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(" By : " + _vm._s(row1.item.raisedBy))]), _c('br'), _vm._v(" "), (
          row1.item.sob_date_detected != '' &&
          row1.item.sob_date_detected != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v(" SOB : " + _vm._s(row1.item.sob_date_detected) + " ")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v(" SAILED ")])])], 1) : _vm._e(), _c('br'), _vm._v(" "), (row1.item.SplitedStatus != '0') ? _c('Splitmerge-Summary', {
          staticClass: "mt-2",
          attrs: {
            "SM_Status": 1,
            "title": 'Split & Merge Track - ',
            "SM_all_module_id": row1.item.allModuleId,
            "SM_jb_series": row1.item.AssNo
          }
        }) : _vm._e(), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("\n                Summary & Documents ")]), _c('br'), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.AssNo
          }
        }), _vm._v(" "), _c('Quotation-Summary', {
          attrs: {
            "QT_fk_all_module_id": row1.item.allModuleId,
            "QT_jb_series": row1.item.AssNo
          }
        }), _vm._v(" "), (row1.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.AssNo,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.AssNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.AssNo,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.AssNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.allModuleId),
            "JobNo": row1.item.AssNo
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Lats Updated Dt. : " + _vm._s(row1.item.latestUpdateForBilling))])]
      }
    }, {
      key: "shipperName",
      fn: function(row2) {
        return [_c('span', [_vm._v(" " + _vm._s(row2.item.TPTClient)), _c('br')])]
      }
    }, {
      key: "containerNo",
      fn: function(row3) {
        return [(row3.item.containerNo) ? _c('div', _vm._l((row3.item.containerNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "shipper_Inv",
      fn: function(row4) {
        return [(row4.item.containerNo) ? _c('div', _vm._l((row4.item.containerNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "locations",
      fn: function(row5) {
        return [_c('span', [_vm._v("POR : " + _vm._s(row5.item.POR)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("POL : " + _vm._s(row5.item.POL)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("POD : " + _vm._s(row5.item.POD)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("FPOD : " + _vm._s(row5.item.FPOD)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Client : " + _vm._s(row5.item.clientName)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Sline : " + _vm._s(row5.item.shippingLine)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("MBLNO : " + _vm._s(row5.item.MBLNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("HBLNO : " + _vm._s(row5.item.HBLNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("SOB : " + _vm._s(row5.item.sob_date_detected)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Vessel : " + _vm._s(row5.item.vessel_voyage))])]
      }
    }, {
      key: "status",
      fn: function(row6) {
        return [(row6.item.ManualStatus != '' && row6.item.ManualStatus != null) ? _c('span', [_vm._v("\n                Manual Status :\n                "), (row6.item.ManualStatus == 'Active') ? _c('span', {
          style: (row6.item.ManualStatus ? 'color: green' : 'color: red')
        }, [_vm._v(_vm._s(row6.item.ManualStatus))]) : _vm._e()]) : _vm._e(), _c('br'), _vm._v(" "), (row6.item.status != '' && row6.item.status != null) ? _c('span', [_vm._v("\n                Expense Status :\n                "), (row6.item.status == 'Active') ? _c('span', {
          style: (row6.item.status ? 'color: green' : 'color: red')
        }, [_vm._v(_vm._s(row6.item.status))]) : _vm._e()]) : _vm._e(), _c('br')]
      }
    }, {
      key: "Payment_Status",
      fn: function(row7) {
        return [_c('b-badge', {
          attrs: {
            "variant": row7.item.Payment_Status == 'Yes' ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v(_vm._s(row7.item.Payment_Status))])]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row7.item.billingType == 'Overseas Billing' ? 'success' : 'info'
          }
        }, [_c('b', [_vm._v(_vm._s(row7.item.billingType))])])]
      }
    }, {
      key: "mainEnquiryId",
      fn: function(row8) {
        return [_c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.proceedBilling(row8.item.allModuleId, row8.item.doc_id)
            }
          }
        }, [_vm._v("\n                " + _vm._s("Proceed To Expense") + "\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), ((row8.item.finalBillingCompleted == '1' ||
          (row8.item.billingType == 'Overseas Billing' &&
            row8.item.closedOverseasStatus == 'Overseas Closed'))) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed")]) : (row8.item.finalBillingCompleted == '4') ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed - Agent Expense Pending")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Billing In-complete")]), _vm._v(" "), _c('br')]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("\n            Close\n          ")])], 1)], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "8",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd1933c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/expense/allPurchases.vue
// module id = 2396
// module chunks = 0